import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import Loader from '@rsos/components/capstone/Loader/Loader';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { setAdrQueryStatus } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { useSelectedCall } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { NoData } from './AdrQueryContainer.styles';

const trackButtonClick = () => {
  gspx.trackEvent({
    name: 'event_pane_adr_query_button_click',
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.EVENT_PANE,
    additionalKeys: {
      legacy_category: 'ADR',
      legacy_name: 'User clicks on ADR Query button',
      Category: 'ADR',
      'Launched date': new Date(),
    },
  });
};

const RequestAdr = () => {
  const selectedCall = useSelectedCall();
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const dispatch = useDispatch();

  const adrQueryData = selectedCall?.adrQuery;

  const isFetched = adrQueryData.fetched;
  const isLoading = adrQueryData.loading;
  const hasData = adrQueryData?.hasData;

  /**
   * Function to update the loading status for the adr query to trigger a Hermes
   * subscription
   */
  const handleClick = useCallback(() => {
    dispatch(
      setAdrQueryStatus({
        callerID: selectedCallerID,
        loading: true,
        fetched: false,
      }),
    );
    trackButtonClick();
  }, [dispatch, selectedCallerID]);

  if (!hasData) {
    return (
      <>
        <Box width="100%" mb="16px">
          <Button grow onClick={handleClick} disabled={isLoading} noMargin>
            Check for Additional Apple Data
          </Button>
        </Box>
        {isLoading && (
          <Box width="100%" horizontal justify="center">
            <Loader />
          </Box>
        )}
        {isFetched && (
          <NoData horizontal px="12px" py="20px">
            <Box pr="12px" justify="center">
              <AttentionTriangleIcon />
            </Box>
            <Text size="normal">
              Failed to retrieve additional data. Click the above button to try
              again
            </Text>
          </NoData>
        )}
      </>
    );
  }
  return null;
};

export default RequestAdr;
